exports.shouldUpdateScroll = () => {
  document.body.scrollTop = 0
  // return false
}
